export default __webpack_public_path__ + "static/media/planets.17ec5884.jpg";